/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ComponentProps, useState } from 'react';

type FileInputProps = ComponentProps<'input'>;

type Props = FileInputProps & {
  innerRef?: React.RefObject<HTMLInputElement>;
  onFileSelect: (files: Array<File>) => void;
  testID?: string;
};

function FilePicker(props: Props) {
  let { innerRef, onFileSelect, testID, ...otherProps } = props;
  let [count, setCount] = useState(0);
  return (
    <span style={styles.container as any}>
      <input
        {...otherProps}
        data-testid={testID}
        key={count}
        ref={innerRef}
        type="file"
        tabIndex={-1}
        onChange={(event) => {
          let input: HTMLInputElement = event.target;
          let files: Array<File> = input.files ? Array.from(input.files) : [];
          setCount((count) => count + 1);
          onFileSelect(files);
        }}
      />
    </span>
  );
}

let styles = {
  container: {
    display: 'block',
    width: 0,
    height: 0,
    position: 'absolute',
    left: 0,
    top: 0,
    overflow: 'hidden',
  },
};

export default FilePicker;
